import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/ui-stack/ui/base/button';

/**
 * Draws the inline container for filters
 * */
class InlineFilterContainer extends Component {
  static displayName = 'InlineFilterContainer';

  static propTypes = {
    expanded: PropTypes.bool,
  };

  static defaultProps = {
    expanded: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded,
    };

    this.onToggleClick = this.onToggleClick.bind(this);
  }

  /**
   * Toggle button click handler
   * Toggles if component is expenaded or not
   * */
  onToggleClick() {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }

  render() {
    const { children, label, className, width } = this.props;
    const { expanded } = this.state;

    return (
      <div className={`${className} ${width} inline-filter-controls-container`}>
        <Button isSecondary onClick={this.onToggleClick}>
          {label}
        </Button>
        {(expanded && children) || null}
      </div>
    );
  }
}

export default InlineFilterContainer;
